




const pack = require('../package.json')


const url = process.env.NODE_ENV !== "development" ? "https://app.gnyn.site" : "http://localhost:3434"
//const url = "http://localhost:3434"


export const apiBaseUrl = url

export const cdnUrl = "https://cdn.geliyoorum.com"

//facebook  //appp name : Piyan meet
export const facebookAppId = "1140265152979412";
export const facebookAppScreet = "1eee2c4d35044202193bae58c76fc0a3";

//google
export const googleClientId = "529245241781-r00lvd4c7o116t7ikjtk3t6r7klbueqi.apps.googleusercontent.com"
export const googlePrivateKey = "h8kECnD9Y7SK12_Ltln1Mxzv"


export const getToken = () => {
    return localStorage.getItem('token');
}


//dil ayarları

export const getDefaultLanguage = () => {
    const lang = localStorage.getItem('language');
    return lang ? lang : "tr";
}
export const setDefaultLanguage = async (lang) => {
    /*
    import stores from "./stores"
    const token = await stores.UserStore.getToken()
    if (token) {
        stores.UserStore.setLanguage(lang)
    }
    localStorage.setItem('language', lang);
    return lang
    */
}

//yazdırma ayarları

const defaultPrintData = {
    descriptionen: "Please enter the link below from your web browser and read the code",
    descriptiontr: "Lütfen web tarayıcınızdan aşağıdaki linke girip kodu okutun",
    qrreadurl: "menu.piyanrest.com",
    size: "middle"
}

export const getPrintConfig = () => {
    const printconfig = localStorage.getItem('printconfig');
    let data = null
    try {
        data = JSON.parse(printconfig)
    } catch (error) {
        data = defaultPrintData
    }
    return (data && data.descriptionen != "") ? data : defaultPrintData
}
export const setPrintConfig = (data) => {
    try {
        localStorage.setItem("printconfig", JSON.stringify(data))
    } catch (error) {
        data = defaultPrintData
        localStorage.setItem("printconfig", JSON.stringify(data))
    }

    return data
}

const apiPrefix = '/api';


/// ürün ismi
export const appName = "Ganyan";

//exports

export const API_URL = `${apiBaseUrl}/api`; // "http://localhost:3232/api" //`${apiBaseUrl}/api`;



export const siteInfo = {
    siteName: 'novelbet',
    copyright: `Eğlence Platformu © ${new Date().getFullYear()} novelbet`,
}

